// extracted by mini-css-extract-plugin
export default {"infoCircle":"styles_infoCircle__I0tCn"};